import React, { useEffect, useState, Fragment } from 'react'
import { Carousel } from 'react-responsive-carousel'
import { getUrlFromAStream } from '../../../../utils/getUrlByFileStream'
import { NoInfo } from '../../../common/NoInfo'
import ReactPlayer from 'react-player/youtube'
import { articlesApi } from '../../../../api/articlesApi'
import _ from 'lodash'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader

const ViewVideoOrImgs = (
    {
        buttonViewImg,
        itemSelected,
    }
) => {

    const [allProductImages, setAllProductImages] = useState([])

    const filterProductsImages = async (itemSelected) => {
        if (!_.isEmpty(itemSelected)) {
            let getAllProductsThatHaveImg = await articlesApi.getArticleImgs(itemSelected.id_Articulo)
            let allUrlImg = []
            for (let img in getAllProductsThatHaveImg.data) {
                const url = await getUrlFromAStream(getAllProductsThatHaveImg.data[img].ruta, 'application/image')
                allUrlImg.push(url)
            }
            setAllProductImages(allUrlImg)
        }
    }

    useEffect(() => {
        filterProductsImages(itemSelected)
    }, [itemSelected])

    return (
        <>
            {buttonViewImg 
                ? <Fragment>
                        {
                            allProductImages.length > 0 ?
                                <Carousel autoPlay >
                                    {
                                         allProductImages.map((url, i) =>
                                            <div key={ i }>
                                                <img alt="img" src={url} />
                                            </div>
                                        )
                                    }
                                </Carousel>
                            : NoInfo("No hay imágenes")
                        }
                    </Fragment>
                :
                    <Fragment>
                        {
                            itemSelected.link !== ''  || null ? 
                                <div className="product-detail__video">
                                    <ReactPlayer url={itemSelected.link} width='100%' height='100%' controls/>
                                </div>
                            :  NoInfo("No hay vídeo")
                        }
                    </Fragment>
            }
        </>
    )
}
export default ViewVideoOrImgs